<template>
  <div class="choujian-list">
    <el-breadcrumb separator="/" style="margin-bottom: 15px">
      <el-breadcrumb-item>运营部</el-breadcrumb-item>
      <el-breadcrumb-item>筹建列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索区 -->
    <el-card shadow="never" style="margin-top: 15px">
      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" @tab-click="onTabClick" style="margin-bottom: 5px">
        <el-tab-pane label="筹建项目" name="choujian"></el-tab-pane>
        <el-tab-pane label="转让项目" name="transfer"></el-tab-pane>
      </el-tabs>

      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.keyword"
            placeholder="模糊搜索"
            clearable
            @clear="onSearch"
          />
        </el-form-item>
        <el-form-item label="品牌">
          <el-select v-model="searchForm.signType" placeholder="请选择" clearable style="width: 120px" @change="onSearch">
            <el-option
              v-for="item in brandOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="筹建督导">
          <el-select v-model="searchForm.supervisorId" placeholder="请选择" clearable filterable style="width: 120px" @change="onSearch">
            <el-option
              v-for="item in supervisorOptions"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="activeTab === 'choujian'" label="阶段">
          <el-select v-model="searchForm.stage" placeholder="请选择" clearable style="width: 120px" @change="onSearch">
            <el-option
              v-for="item in stageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="activeTab === 'choujian' ? '移交时间' : '转让时间'">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 状态筛选 -->
      <div class="status-filter-row">
        <span class="status-filter-label">状态：</span>
        <el-checkbox-group v-model="searchForm.statusList" size="small" @change="onSearch">
          <el-checkbox v-for="item in currentStatusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </div>

    </el-card>

    <!-- 列表区 -->
    <el-card shadow="never" style="margin-top: 15px">
      <!-- 筹建表格 -->
      <el-table
        v-if="activeTab === 'choujian'"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <!-- 固定列 -->
        <el-table-column type="index" fixed="left" label="#"/>
        <el-table-column prop="projectName" label="项目名称" fixed="left" min-width="180">
          <template slot-scope="{ row }">
            <span v-if="row.handoverStatus !== 1" class="clickable-name bold" @click="goDetail(row)">{{ row.projectName }}</span>
            <span v-else class="bold">{{ row.projectName }}</span>
            <div class="customer-name">客户：{{ row.customerName }}</div>
            <div v-if="row.templateName" class="template-name">{{ row.templateName }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="supervisorName" label="筹建督导" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.supervisorName && row.supervisorName !== '--'" class="clickable-name" @click="filterBySupervisor(row)">{{ row.supervisorName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="附加信息" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="showAdditionalInfo(row)">查看详情</el-button>
            <span v-if="getRentDisplay(row)" :style="{ fontSize: '11px', marginLeft: '12px', color: getRentDisplay(row).isZero ? '#F56C6C' : '#909399' }">{{ getRentDisplay(row).text }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.handoverStatus === 1" type="warning" size="mini" effect="dark">待接收</el-tag>
            <el-tag v-else-if="row.handoverStatus === 2" type="primary" size="mini" effect="dark">筹建中</el-tag>
            <el-tag v-else-if="row.handoverStatus === 3 && row.transferOutInfo && row.transferOutInfo.toProjectId" type="warning" size="mini" effect="dark">已转让</el-tag>
            <el-tag v-else-if="row.handoverStatus === 3" type="danger" size="mini" effect="dark">已解约</el-tag>
            <el-tag v-else-if="row.handoverStatus === 4" type="success" size="mini" effect="dark">已完成</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="进度" width="120">
          <template slot-scope="{ row }">
            <el-progress
              v-if="row.progress"
              type="line"
              :percentage="row.progress.percentage"
              :stroke-width="6"
              text-color="#409EFF"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column prop="signerName" label="签约人" width="80">
          <template slot-scope="{ row }">
            <span class="font12">{{row.signerName}}</span>
          </template>
        </el-table-column>

        <el-table-column label="移交日期" width="100">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.handoverDate | date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="接收日期" width="100">
          <template slot-scope="{ row }">
            <div class="font12">
              <span v-if="row.handoverStatus === 1" style="color: #909399">未接收</span>
              <span v-else>{{ row.acceptedDate | date }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="筹建天数" width="80">
          <template slot-scope="{ row }">
            <span class="font12">{{ calcChoujianDays(row) }}</span>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.handoverStatus !== 1"
              size="mini"
              type="primary"
              plain
              @click="goDetail(row)"
            >详情</el-button>
            <span v-else class="font12" style="color: #909399">--</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 转让表格 -->
      <el-table
        v-if="activeTab === 'transfer'"
        :data="transferTableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column type="index" fixed="left" label="#"/>
        <el-table-column prop="projectName" label="项目名称" fixed="left" min-width="180">
          <template slot-scope="{ row }">
            <span class="clickable-name bold" @click="goTransferDetail(row)">{{ row.projectName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户" width="120" />
        <el-table-column prop="supervisorName" label="筹建督导" width="100">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.supervisorName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="signerName" label="签约人" width="80">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.signerName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="signType" label="品牌" width="80" />

        <!-- 三项节点状态 -->
        <el-table-column label="营业执照" width="110">
          <template slot-scope="{ row }">
            <div class="font12" v-if="row.nodes && row.nodes.BUSINESS_LICENSE">
              <span v-if="row.nodes.BUSINESS_LICENSE.completed">
                <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                {{ row.nodes.BUSINESS_LICENSE.completedAt | date }}
              </span>
              <span v-else style="color: #909399;">
                <i class="el-icon-time"></i> 待处理
              </span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="美团订货注册" width="110">
          <template slot-scope="{ row }">
            <div class="font12" v-if="row.nodes && row.nodes.MEITUAN_ORDER_REGISTER">
              <span v-if="row.nodes.MEITUAN_ORDER_REGISTER.completed">
                <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                {{ row.nodes.MEITUAN_ORDER_REGISTER.completedAt | date }}
              </span>
              <span v-else style="color: #909399;">
                <i class="el-icon-time"></i> 待处理
              </span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="签订管理协议" width="110">
          <template slot-scope="{ row }">
            <div class="font12" v-if="row.nodes && row.nodes.MANAGEMENT_AGREEMENT">
              <span v-if="row.nodes.MANAGEMENT_AGREEMENT.completed">
                <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                {{ row.nodes.MANAGEMENT_AGREEMENT.completedAt | date }}
              </span>
              <span v-else style="color: #909399;">
                <i class="el-icon-time"></i> 待处理
              </span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="进度" width="120">
          <template slot-scope="{ row }">
            <el-progress
              v-if="row.progress"
              type="line"
              :percentage="row.progress.percentage"
              :stroke-width="6"
              text-color="#409EFF"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 'IN_PROGRESS'" type="warning" size="mini" effect="dark">进行中</el-tag>
            <el-tag v-else-if="row.status === 'COMPLETED'" type="success" size="mini" effect="dark">已完成</el-tag>
            <el-tag v-else size="mini">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="转让日期" width="100">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.startedAt | date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" plain @click="goTransferDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页（筹建） -->
      <el-pagination
        v-if="activeTab === 'choujian'"
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />

      <!-- 分页（转让） -->
      <el-pagination
        v-if="activeTab === 'transfer'"
        style="margin-top: 15px; text-align: right"
        @size-change="handleTransferSizeChange"
        @current-change="handleTransferCurrentChange"
        :current-page="transferPagination.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="transferPagination.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="transferPagination.total"
      />
    </el-card>

    <!-- 附加信息弹框（只读，两列：左列键值对附加信息，右列首批物料备忘） -->
    <el-dialog
      title="附加信息"
      :visible.sync="additionalInfoDialogVisible"
      width="840px"
      top="8vh"
      :close-on-click-modal="false"
    >
      <template v-if="currentAdditionalInfoRow">
        <div class="additionalInfoColumns">
          <!-- 左列：键值对附加信息 -->
          <div class="additionalInfoCol">
            <div class="additionalInfoColTitle">附加信息</div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item
                v-for="(value, key) in currentAdditionalInfoRow.additionalInfo"
                :key="key"
                :label="key"
              >
                <span v-html="getMultLine(value)"></span>
              </el-descriptions-item>
            </el-descriptions>
            <div v-if="!currentAdditionalInfoRow.additionalInfo || Object.keys(currentAdditionalInfoRow.additionalInfo).length === 0" style="color: #909399; text-align: center; padding: 20px;">
              暂无附加信息
            </div>
          </div>

          <!-- 右列：首批物料备忘（列表接口下发字段；转让 tab 行无该字段显示占位） -->
          <div class="additionalInfoCol">
            <div class="memoColTitle"><i class="el-icon-warning-outline"></i> 首批物料备忘（招商部提供）</div>
            <template v-if="hasMemo(currentAdditionalInfoRow.firstMaterialMemo)">
              <div class="memoBlockText" v-if="currentAdditionalInfoRow.firstMaterialMemo.text">{{ currentAdditionalInfoRow.firstMaterialMemo.text }}</div>
              <div class="memoBlockImages" v-if="currentAdditionalInfoRow.firstMaterialMemo.images && currentAdditionalInfoRow.firstMaterialMemo.images.length">
                <el-image
                  v-for="(img, idx) in currentAdditionalInfoRow.firstMaterialMemo.images"
                  :key="idx"
                  :src="getMemoImg(img)"
                  :preview-src-list="currentAdditionalInfoRow.firstMaterialMemo.images.map(i => getMemoImg(i))"
                  style="width: 40px; height: 40px; margin-right: 6px; cursor: pointer; border-radius: 4px;"
                  fit="cover">
                </el-image>
              </div>
            </template>
            <div v-else class="memoEmpty">暂无首批物料备忘</div>
          </div>
        </div>
      </template>
      <div slot="footer">
        <el-button @click="additionalInfoDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 首批物料备忘统一内容判空：兼容 undefined（历史文档）与空对象两种形态
const hasMemo = m => !!((m && m.text && m.text.trim()) || (m && m.images && m.images.length))

export default {
  name: 'ChoujianList',
  data () {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        keyword: '',
        signType: '',
        supervisorId: '',
        statusList: [2],
        stage: '',
        dateRange: null
      },
      brandOptions: [
        { label: '美滋滋', value: '美滋滋' },
        { label: '蛮碗香', value: '蛮碗香' },
        { label: '虎头张', value: '虎头张' },
        { label: '长安大东家', value: '长安大东家' }
      ],
      stageOptions: [
        { label: '选址', value: 'site_selection' },
        { label: '首次沟通', value: 'FIRST_COMMUNICATION' },
        { label: '管家注册', value: 'MEITUAN_ORDER_REGISTER' },
        { label: '线上检查', value: 'ONLINE_CHECK' },
        { label: '实操培训', value: 'PRACTICAL_TRAINING_COMPLETE' },
        { label: '账号创建', value: 'ACCOUNT_CREATE' }
      ],
      statusOptions: [
        { label: '待接收', value: 1 },
        { label: '筹建中', value: 2 },
        { label: '已解约', value: 3 },
        { label: '已完成', value: 4 }
      ],
      pagination: {
        pagenum: 1,
        pagesize: 50,
        total: 0
      },
      supervisorOptions: [],
      // 附加信息弹框相关
      additionalInfoDialogVisible: false,
      currentAdditionalInfoRow: null,
      // tab 切换
      activeTab: 'choujian',
      // 转让列表
      transferTableData: [],
      transferPagination: { pagenum: 1, pagesize: 50, total: 0 }
    }
  },
  computed: {
    currentStatusOptions () {
      if (this.activeTab === 'transfer') {
        return [
          { value: 'IN_PROGRESS', label: '进行中' },
          { value: 'COMPLETED', label: '已完成' }
        ]
      }
      return this.statusOptions
    }
  },
  created () {
    this.loadData()
    this.loadSupervisorOptions()
  },
  methods: {
    async loadData () {
      this.loading = true
      try {
        const params = {
          pagenum: this.pagination.pagenum,
          pagesize: this.pagination.pagesize
        }
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword
        if (this.searchForm.signType) params.signType = this.searchForm.signType
        if (this.searchForm.supervisorId) params.supervisorId = this.searchForm.supervisorId
        if (this.searchForm.statusList && this.searchForm.statusList.length > 0) {
          params.statusList = this.searchForm.statusList.join(',')
        }
        if (this.searchForm.stage) params.stage = this.searchForm.stage
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDate = this.searchForm.dateRange[0]
          params.endDate = this.searchForm.dateRange[1]
        }

        const { data: res } = await this.$http.get('yunying/choujian/list', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.tableData = res.data.list
        this.pagination.total = res.data.total
      } catch (err) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadSupervisorOptions () {
      try {
        const { data: res } = await this.$http.get('process/getEmployeeList', { params: { role: 'supervisor' } })
        if (res.meta.status === 200) {
          this.supervisorOptions = res.data
        }
      } catch (err) {
        // 忽略错误
      }
    },
    calcChoujianDays (row) {
      if (row.handoverStatus === 1 || row.handoverStatus === 3) {
        return '--'
      }
      if (!row.acceptedDate) return '--'
      const start = new Date(row.acceptedDate)
      let end
      if (row.handoverStatus === 4 && row.completedAt) {
        end = new Date(row.completedAt)
      } else {
        end = new Date()
      }
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24))
      return days + '天'
    },
    getMultLine (value) {
      if (value === null || value === undefined || value === '') return '--'
      // 先转义再换行：值来自表单录入，防止 v-html 渲染注入的 HTML
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .split('\n')
        .join('<br>')
    },
    // 房租显示：值为 '0' 或 0 时用红色提示"无房租信息"，其他值灰色显示，无值不显示
    getRentDisplay (row) {
      const info = row.additionalInfo
      if (!info || info['房租'] === undefined || info['房租'] === null || info['房租'] === '') return null
      const raw = String(info['房租']).trim()
      if (raw === '0' || raw === '0元' || raw === '0.00' || raw === '0.0') {
        return { text: '无房租信息', isZero: true }
      }
      return { text: `房租：${raw}`, isZero: false }
    },
    handleSearch () {
      this.pagination.pagenum = 1
      this.loadData()
    },
    // 统一搜索分发（按 tab）
    onSearch () {
      if (this.activeTab === 'choujian') {
        this.handleSearch()
      } else {
        this.handleTransferSearch()
      }
    },
    resetSearch () {
      if (this.activeTab === 'choujian') {
        this.searchForm = { keyword: '', signType: '', supervisorId: '', statusList: [2], stage: '', dateRange: null }
      } else {
        this.searchForm = { keyword: '', signType: '', supervisorId: '', statusList: ['IN_PROGRESS', 'COMPLETED'], stage: '', dateRange: null }
      }
      this.onSearch()
    },
    handleSizeChange (val) {
      this.pagination.pagesize = val
      this.pagination.pagenum = 1
      this.loadData()
    },
    handlePageChange (val) {
      this.pagination.pagenum = val
      this.loadData()
    },
    goDetail (row) {
      // 防护：已解约但从未接收的项目无流程实例，不可进详情
      if (!row.instanceId) {
        return this.$message.warning('该项目暂无筹建流程，无法查看详情')
      }
      this.$router.push(`/yunying/choujian/detail/${row.instanceId}`)
    },
    filterBySupervisor (row) {
      const supervisor = this.supervisorOptions.find(s => s.name === row.supervisorName)
      if (supervisor) {
        this.searchForm.supervisorId = supervisor._id
        this.handleSearch()
      }
    },
    showAdditionalInfo (row) {
      this.currentAdditionalInfoRow = row
      this.additionalInfoDialogVisible = true
    },

    // 统一内容判空（模板可用）
    hasMemo,

    // 首批物料备忘截图地址（相对路径拼附件基地址）
    getMemoImg (img) {
      return (window.sessionStorage.getItem('base') || '') + img
    },

    // ==================== 转让 tab 相关方法 ====================

    // 加载转让列表
    async loadTransferList () {
      this.loading = true
      try {
        const params = {
          pagenum: this.transferPagination.pagenum,
          pagesize: this.transferPagination.pagesize
        }
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword
        if (this.searchForm.signType) params.signType = this.searchForm.signType
        if (this.searchForm.supervisorId) params.supervisorId = this.searchForm.supervisorId
        if (this.searchForm.statusList && this.searchForm.statusList.length > 0) {
          params.statusList = this.searchForm.statusList.join(',')
        }
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDate = this.searchForm.dateRange[0]
          params.endDate = this.searchForm.dateRange[1]
        }

        const { data: res } = await this.$http.get('yunying/choujian/transfer-list', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.transferTableData = res.data.list
        this.transferPagination.total = res.data.total
      } catch (err) {
        this.$message.error('加载转让列表失败')
      } finally {
        this.loading = false
      }
    },

    // Tab 点击（Element UI 2.x 的 el-tabs 用 tab-click 事件）
    // v-model 已在事件触发前更新，this.activeTab 是新值
    onTabClick () {
      this.handleTabChange()
    },

    // 统一的 tab 切换处理
    handleTabChange () {
      this.pagination.pagenum = 1
      this.transferPagination.pagenum = 1
      // 重置状态（两套状态值类型不同，不能混用；筹建默认仅勾选“筹建中”）
      if (this.activeTab === 'choujian') {
        this.searchForm.statusList = [2]
      } else {
        this.searchForm.statusList = ['IN_PROGRESS', 'COMPLETED']
      }
      // 清除阶段（转让无阶段概念）
      if (this.activeTab === 'transfer') this.searchForm.stage = ''
      // 触发对应列表加载
      if (this.activeTab === 'choujian') {
        this.loadData()
      } else {
        this.loadTransferList()
      }
    },

    // 转让列表搜索/翻页
    handleTransferSearch () {
      this.transferPagination.pagenum = 1
      this.loadTransferList()
    },
    handleTransferSizeChange (val) {
      this.transferPagination.pagesize = val
      this.transferPagination.pagenum = 1
      this.loadTransferList()
    },
    handleTransferCurrentChange (val) {
      this.transferPagination.pagenum = val
      this.loadTransferList()
    },

    // 转让详情跳转（复用运营端 ChoujianDetail.vue）
    goTransferDetail (row) {
      this.$router.push(`/yunying/choujian/detail/${row.instanceId}`)
    }
  }
}
</script>

<style scoped>
/* 弹窗两列布局（左键值对/右备忘）与大图预览层级（防被 dialog 遮挡） */
::v-deep .el-image-viewer__wrapper {
  z-index: 3000 !important;
}
.additionalInfoColumns {
  display: flex;
  gap: 20px;
  align-items: stretch;
}
.additionalInfoCol {
  flex: 1;
  min-width: 0;
}
.additionalInfoColTitle {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}
.memoColTitle {
  font-size: 14px;
  font-weight: bold;
  color: #B88230;
  margin-bottom: 10px;
}
.memoEmpty {
  color: #909399;
  text-align: center;
  padding: 20px 0;
  font-size: 13px;
}
.memoBlockText {
  font-size: 13px;
  color: #606266;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-all;
  background: #FDF6EC;
  border-left: 3px solid #E6A23C;
  border-radius: 4px;
  padding: 8px 10px;
  max-height: 300px;
  overflow-y: auto;
}
.memoBlockImages {
  margin-top: 8px;
}

.clickable-name {
  color: #409EFF;
  cursor: pointer;
}
.clickable-name:hover {
  text-decoration: underline;
}
.bold{
  font-weight: bold;
}
.font12{
  font-size: 12px;
}
.customer-name {
  font-size: 11px;
  color: #606266;
  margin-top: 2px;
}
.template-name {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}

/* 状态筛选行 */
.status-filter-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.status-filter-label {
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
}
</style>
